module.exports = __webpack_public_path__ + "static/promotionImage-068cec5749f2eb43ba23401087b16524.jpg";